import { createFileRoute } from "@tanstack/react-router";
import { CustomerBookingPortalPage } from "@/features/public-booking/CustomerBookingPortalPage";

export const Route = createFileRoute("/booking/me")({
  component: CustomerBookingMeRoute,
});

function CustomerBookingMeRoute() {
  return <CustomerBookingPortalPage />;
}
